export enum DelegationPermission {
  None = 0,
  Selskabsblanketten = 1,
  Efteruddannelse = 2,
  Sign = 4,
}

export const DELEGATION_PERMISSION_OPTIONS = [
  {
    flag: DelegationPermission.Selskabsblanketten,
    label: "Virksomhedsblanketten",
  },
  {
    flag: DelegationPermission.Efteruddannelse,
    label: "Efteruddannelse",
  },
] as const;

export const hasDelegationPermission = (
  flags: number,
  permission: DelegationPermission,
) => (flags & permission) === permission;

export const permissionsToLabels = (flags: number): string[] =>
  DELEGATION_PERMISSION_OPTIONS.filter(({ flag }) =>
    hasDelegationPermission(flags, flag),
  ).map(({ label }) => label);

export const permissionsToLabelString = (flags: number): string =>
  permissionsToLabels(flags).join(", ") || "Ingen rettigheder";

export const togglePermission = (
  current: number,
  permission: DelegationPermission,
  checked: boolean,
): number => (checked ? current | permission : current & ~permission);

export const canAccessAsDelegate = (
  userInfo: {
    isDelegatedSession?: boolean;
    delegationPermissions?: number | null;
  },
  permission: DelegationPermission,
) => {
  if (!userInfo.isDelegatedSession) return true;
  if (userInfo.delegationPermissions == null) return false;
  return hasDelegationPermission(userInfo.delegationPermissions, permission);
};
